<ng-container *ngIf="!isLoading(); else loading">
  <ng-container *ngIf="!apps() || apps().length === 0; else warning">
    <glxy-empty-state [size]="'small'">
      <glxy-empty-state-title>
        {{ 'NO_APPS' | translate }}
      </glxy-empty-state-title>
      <a *ngIf="showInboxSettingsLink && apps().length === 0" [routerLink]="inboxSettingsRoute()" target="_blank">
        {{ 'INBOX_SETTINGS.PROMPT' | translate }}
        <mat-icon inline="true" class="open-in-new" iconPositionEnd>open_in_new</mat-icon>
      </a>
    </glxy-empty-state>
  </ng-container>

  <ng-template #warning>
    <span>{{ 'APPS_WARNING' | translate }}</span>
    <mat-list>
      <mat-list-item *ngFor="let app of apps()">
        <span matListItemTitle>{{ app.name }}</span>
        <a target="_blank" [routerLink]="app.configurationUrl">{{ 'APPLICATION_SETTINGS' | translate }}</a>
      </mat-list-item>
    </mat-list>
  </ng-template>
</ng-container>

<ng-template #loading>
  <glxy-loading-spinner></glxy-loading-spinner>
</ng-template>
